import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { ErrorResponse } from '~/infra/ErrorResponse';
export function useCustomerDetail(clientId) {
    const { api } = useStoreActions();
    const { data, isLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.CustomerDetail,
            clientId
        ],
        queryFn: ()=>api.client.getById(clientId),
        enabled: clientId !== '',
        refreshOnHookMount: true
    });
    const isNotFound = error != null && new ErrorResponse(error).hasStatus([
        404
    ]);
    return {
        clientDetails: data,
        isLoading,
        isError: error != null && !isNotFound,
        isNotFound,
        refresh
    };
}
